import type { GroupWithMembers } from '@/api/groups';

/**
 * Sort groups by user's display_order (ascending), then joined_at DESC.
 * Mirrors mobile app logic from useRxDBGroups.ts.
 */
export function sortGroupsForUser(groups: GroupWithMembers[], userId: string): GroupWithMembers[] {
  return [...groups].sort((a, b) => {
    const memberA = a.members.find(m => m.user_id === userId);
    const memberB = b.members.find(m => m.user_id === userId);
    const orderA = memberA?.display_order;
    const orderB = memberB?.display_order;

    // Both have explicit order: ascending
    if (orderA != null && orderB != null) return orderA - orderB;
    // Only one has explicit order: it comes first
    if (orderA != null) return -1;
    if (orderB != null) return 1;
    // Neither: sort by joined_at DESC (newest first)
    const dateA = memberA?.joined_at ? new Date(memberA.joined_at).getTime() : 0;
    const dateB = memberB?.joined_at ? new Date(memberB.joined_at).getTime() : 0;
    return dateB - dateA;
  });
}
